var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignalCellularBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_811_7642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 3.33333H16.25V16.6667H13.75V3.33333ZM3.75 11.6667H6.25V16.6667H3.75V11.6667ZM8.75 7.49999H11.25V16.6667H8.75V7.49999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.7071,
    y1: 3.70711,
    x2: 1.70711,
    y2: 19.7071,
    stroke: "#F2484B",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_811_7642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalCellularBad);
export default __webpack_public_path__ + "static/media/signal-cellular-bad.60ba30d366d9044bd091acf04d90e299.svg";
export { ForwardRef as ReactComponent };